module.exports = __webpack_public_path__ + "static/media/logo-main-light.afb337f9.png";